// View namespace fragments (zh/en in same file, kept in sync)
import dashboard from './views/dashboard'
import launch from './views/launch'
import formtpl from './views/formtpl'
import assets from './views/assets'
import landing from './views/landing'
import guard from './views/guard'
import lplogs from './views/lplogs'
import adsExtra from './views/ads'
import admanager from './views/admanager'

// English message dictionary. Mirrors zh.js key-for-key.
export default {
  tg: {
    title: 'Telegram Notifications',
    tabMine: 'My bindings', tabAdd: 'Add binding', tabTeam: 'Team',
    loadFail: 'Failed to load Telegram binding info',
    noneYet: 'Telegram not bound yet — stop-loss and anomaly alerts cannot reach you instantly.',
    bindNow: 'Bind now',
    verifiedAt: 'Last verified {ts}', unverified: 'Unverified (send a test message to verify)', boundAt: 'Bound at {ts}',
    sendTest: 'Send test message', sending: 'Sending…', addAnother: '+ Add another', multiNote: 'Alerts are sent to ALL bound Telegrams.',
    unbind: 'Unbind', unbindConfirm: 'Unbind Telegram {id}? It will no longer receive alerts.', unbound: 'Unbound',
    testSent: 'Test message sent to {n} Telegram(s), please check',
    // Notification scope (TG preference matrix: warning/info toggleable, critical always pushed)
    prefsTitle: 'Notification scope', prefsCritical: 'Critical alerts', prefsLocked: 'Always pushed, cannot be turned off',
    prefsWarning: 'Warning alerts', prefsInfo: 'Info',
    prefsNote: 'Turned-off levels stop going to Telegram only; in-app notifications are unaffected. Critical alerts are always pushed.',
    prefsSaved: '✅ Notification preferences saved',
    step1: 'Open Telegram with the button (or copy the command and send it manually)',
    openTg: 'Open Telegram to bind',
    copyCmd: 'Copy command', cmdCopied: 'Command copied (valid 30 minutes)',
    cmdHint: 'The button will not re-send /start if the bot chat already exists — copy the command above and send it in the bot chat. "Copy command" always gives a fresh code.',
    step2: 'Done when the bot replies "bound" — this page refreshes automatically',
    waiting: 'Waiting for binding result… (auto-detected within seconds)',
    manualFold: 'Alternative: enter numeric chat_id manually',
    manualPh: 'Telegram numeric ID (e.g. 123456789)', manualBind: 'Bind manually',
    manualHint: 'Send /start to the bot first, then paste the numeric ID from its reply.',
    botNotConfigured: 'Admin has not configured a TG bot yet',
    teamEmpty: 'No members', colUser: 'Member', colRole: 'Role', colTg: 'TG binding',
    meTag: ' (me)', noBinding: 'Not bound', teamNote: 'Members without binding get no TG alerts (they can still see in-app notifications).',
    boundToast: '✅ Telegram bound!', opFail: 'Operation failed',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    ok: 'OK',
    close: 'Close',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    delete: 'Delete',
    remove: 'Remove',
    copy: 'Copy',
    copied: 'Copied',
    search: 'Search',
    filterByToken: 'Filter: {name}',
    clearFilter: 'Clear filter',
    custom: 'Custom',
    query: 'Query',
    refresh: 'Refresh',
    exportCsv: 'Export CSV',
    loading: 'Loading…',
    operation: 'Action',
    action: 'Action',
    status: 'Status',
    remark: 'Remark',
    name: 'Name',
    all: 'All',
    none: 'None',
    total: '{n} items',
    yes: 'Yes',
    no: 'No',
    enable: 'Enable',
    disable: 'Disable',
    saved: 'Saved',
    saving: 'Saving',
    discard: 'Discard',
    clear: 'Clear', rename: 'Rename',
    done: 'Done',
    back: 'Back',
    detail: 'Details',
    more: 'More',
    optional: 'Optional',
    required: 'Required',
    noData: 'No data',
    success: 'Success', createdOk: 'Created successfully',
    fail: 'Failed',
    retry: 'Retry',
    export: 'Export',
    import: 'Import',
    preview: 'Preview',
    upload: 'Upload',
    download: 'Download',
    selectPlaceholder: 'Select',
    inputPlaceholder: 'Enter',
    savedOk: 'Saved',
    opFail: 'Operation failed',
    delConfirm: 'Delete? This cannot be undone.',
    tip: 'Tip',
    unit: 'Unit',
    today: 'Today',
    yesterday: 'Yesterday',
    last2days: 'Last 2 days',
    last7days: 'Last 7 days',
    last30days: 'Last 30 days',
  },
  error: {
    copyBtn: 'Copy',
    copiedError: 'Error copied',
    copyFail: 'Copy failed, select manually',
    opFail: 'Operation failed',
    unknown: 'Unknown error',
    uncaptured: 'Uncaptured exception',
    pageError: 'Page error',
    unauthorized: 'Not logged in or session expired, please sign in again',
    timeout: 'Request timed out',
  },
  role: {
    owner: 'Owner',
    operator: 'Operator',
    finance: 'Finance',
    superadmin: 'Platform Admin',
    super: 'Admin',
  },
  nav: {
    groupData: 'Data Center',
    groupAds: 'Ad Management',
    groupAuto: 'Automation',
    groupAuth: 'Authorization',
    groupBilling: 'Billing',
    groupSystem: 'System',
    dashboard: 'Dashboard',
    ads: 'Ad Accounts',
    'ad-manager': 'Ad Manager',
    'launch-templates': 'Launch Templates',
    'form-templates': 'Form Templates',
    assets: 'Asset Library',
    domains: 'Domains',
    landing: 'Ad Links',
    guard: 'Rule Engine',
    tokens: 'Tokens',
    wallet: 'Wallet',
    settings: 'Settings',
    members: 'Members & Roles',
    logs: 'Audit Log',
    'admin-teams': 'Teams',
    'kpi-mapping': 'Conversion Mapping',
  },
  fbError: {
    cert_required: 'Meta non-discrimination certification required',
    invalid_param: 'Invalid parameter',
    bid_required: 'Bid strategy required',
    regulated_opt: 'Optimization goal not available in this region',
    regulated_missing: 'Regulated ad requires verified identity',
    audience: 'Audience targeting rejected',
    audience_size: 'Audience too narrow or invalid',
    abuse: 'Content triggered risk control',
    dev_mode: 'Meta App is in development mode',
    rate_limited: 'Rate limited, retry later',
    rate_concurrent: 'Too many operations within 30 seconds; the last one did not take effect — retry shortly',
    has_spend: 'Has recent spend, keepalive not needed',
    no_write_token: 'No writable token',
    has_keepalive: 'Keepalive ad already exists',
    keepalive_burnt: 'Keepalive failed repeatedly and auto-retry is paused — set "Keepalive page" to the page the account was created with, then click "Keep alive now" to retry',
    no_page: 'No page available',
    no_page_token: 'Token lacks permission for this page',
    no_asset: 'No keepalive asset',
    asset_missing: 'Asset file missing',
    error: 'Unknown error',
    generic: 'Facebook returned an error',
  },
  status: {
    // FB adaccount disable_reason (official semantics, recalibrated in review R3-P1)
    drAdsIntegrity: 'Ads integrity policy', drPaymentFailure: 'Payment failure', drGrayAccount: 'Gray account shut down',
    drRiskPayment: 'Payment risk', drInactiveAccount: 'Inactive account', drUndecided: 'Undecided',
    drUnsupportedBusiness: 'Unsupported business', drMiscMkt: 'misc_mkt',
    drAnCrowdsource: 'AN_CROWDSOURCE', drCanadaCra: 'CANADA_CRA', drChinaBci: 'CHINA_BCI',
    drRpTosViolation: 'RP_TOS_VIOLATION', drMexicoProfeco: 'MEXICO_PROFECO',
    drAgePolicy: 'Age policy', drWeatherSensor: 'WEATHER_SENSOR',
    drGoodStanding: 'GOOD_STANDING_VIOLATED', drRomaniaAnpc: 'ROMANIA_ANPC',
    drMisrepresentation: 'Misrepresentation',
    adActive: 'Active',
    adPaused: 'Paused',
    adCampaignPaused: 'Campaign Paused',
    adsetPaused: 'Ad Set Paused',
    adArchived: 'Archived',
    adDeleted: 'Deleted',
    adDisapproved: 'Disapproved',
    adReview: 'In Review',
    adPreview: 'Preview',
    adInProcess: 'Processing',
    adIdle: 'No active ads',
    adWithIssues: 'With Issues',
    // TikTok ad status (tt_client _STATUS_MAP/_OPT_STATUS + review show_status)
    ttEnable: 'Active',
    ttDisable: 'Paused',
    ttDelete: 'Deleted',
    ttComplete: 'Completed',
    ttBudgetExceed: 'Budget Exhausted',
    ttInProcess: 'Processing',
    ttShowYes: 'Approved',
    ttShowNotStart: 'Not Started',
    ttShowNo: 'Not Approved',
    accActive: 'Active',
    accDisabled: 'Disabled',
    accUnsettled: 'Unsettled',
    accBanned: 'Banned',
    accPendingClose: 'Pending Closure',
    accClosed: 'Closed',
    jobPending: 'Pending',
    jobRunning: 'Running',
    jobCompleted: 'Completed',
    jobPartial: 'Partially Failed',
    jobFailed: 'Failed',
    itemPending: 'Pending',
    itemCreating: 'Creating',
    itemSuccess: '✓ Success',
    itemFail: '✗ Failed',
    subActive: 'Active',
    subReserved: 'Reserved',
    subArchived: 'Archived',
    subDeleted: 'Deleted',
    lpPublished: 'Published',
    lpDraft: 'Draft',
    lpArchived: 'Archived',
    tenantActive: 'Active',
    tenantMustChangePwd: 'Password reset required',
    tenantInvited: 'Invited',
    tenantSuspended: 'Suspended',
    tenantArchived: 'Archived',
    aiPending: 'Pending',
    aiAnalyzing: 'Analyzing',
    aiDone: '✓ Analyzed',
    aiFailed: '✗ Failed',
    aiNone: 'Not analyzed',
    tokenValid: 'Valid',
    tokenInvalid: 'Invalid',
    tokenThrottled: 'Throttled',
    tokenPending: 'Pending Auth',
  },
  cmdk: {
    placeholder: 'Search accounts / templates / pages…',
    noResults: 'No results',
    hint: '↑↓ navigate · Enter go · ESC close',
  },
  layout: {
    platformFilter: 'Platform filter (dashboard / ad manager filter by selected platform)', platformKey: 'Platform ',
    platformScopeAll: 'All platforms · data aggregated across platforms', platformScopeFb: 'Facebook · data filtered to this platform', platformScopeTt: 'TikTok · data filtered to this platform',
    sentinel: 'Sentinel', scdCountdown: 'Countdown', sentinelTip: 'Emergency auto-pause: once on, all delivering campaigns on your accounts are paused', gpGoGuard: 'Open Rule Engine', scdSoon: 'firing soon', scdMin: '{n}m left', scdHr: '{n}h left', scdConflict: 'Sentinel is on (already pausing ads) — turn off the sentinel before enabling the countdown',
    rulesCount: '{n} rules',
    safetyGuard: 'Safety Guard',
    emergencyPause: 'Emergency Pause', lastEmergency: 'Last pause', emergencyTip: 'Immediately pause all ACTIVE campaigns under your accounts (admins: own accounts only)', keepaliveTip: 'Scan and pause at-risk ads under your accounts (keepalive list not exempt)', emgDone: '{n} campaigns paused · {m} accounts scanned', emgBad: '{n} verify/error issues', emgViewLog: 'Click to view the full execution report (Rule Engine · Pause Log)',
    pausing: 'Pausing…',
    emergencyTitle: '⚠️ Emergency Pause',
    emergencyConfirm: 'Pause now? All delivering campaigns on YOUR managed accounts will be paused (whole campaigns, same as sentinel). This cannot be undone.',
    emergencyConfirmBtn: 'Confirm Pause',
    emergencyResultTitle: 'Emergency Pause Result',
    emergencyResult: 'Paused {paused} campaigns (whole campaigns paused) / covered {total} accounts\nVerify failed: {failed}\nDetails in Rule Engine - Pause Log',
    emergencyErrors: 'Errors',
    emergencyStillRunning: 'Emergency pause is still running; check the safety panel later for results',
    emergencyFail: 'Failed: {msg}',
    keepalivePause: 'Stop Keepalive', keepaliveConfirmTitle: '⚠️ Stop Keepalive', keepaliveConfirm: 'Stop keepalive? This pauses all currently-delivering keepalive campaigns on your accounts. This cannot be undone.', keepaliveConfirmBtn: 'Confirm Close', keepaliveResultTitle: 'Stop Keepalive Result', keepaliveResult: 'Paused {paused} keepalive campaigns / scanned {scanned} accounts', keepaliveStillRunning: 'Keepalive stop is still running; check back shortly for results', keepaliveFail: 'Failed: {msg}',
    sentinelTitle: '⚠️ Turn off Sentinel',
    sentinelDisarmConfirm: 'Sentinel is the auto-emergency-stop guard (pauses ads on your accounts when spend is abnormal). Turning it off means abnormal spend on your accounts will no longer be stopped automatically. Turn it off?',
    notifTitle: 'Recent Notifications',
    notifEmpty: 'No notifications', notifViewAll: 'View all alerts → Alert Center', notifAdAlertHint: 'Ad alerts (stop-loss / scaling / tokens / accounts) live here, not in the bell',
    noTeam: 'No team',
    current: 'Current',
    switchedTeam: 'Switched to "{name}"',
    switchFail: 'Switch failed',
    logout: 'Log Out',
    themeToLight: 'Light theme',
    themeToDark: 'Dark theme',
    langToEn: 'Switch to English',
    langToZh: 'Switch to Chinese',
    notMember: 'No team',
  },
  login: {
    title: 'Tova Ads',
    subtitle: 'Intelligent Ad Management Platform',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    signIn: 'Sign In',
    signingIn: 'Signing in…',
    errEmail: 'Please enter email',
    errPassword: 'Please enter password',
    errFill: 'Please enter email and password',
    errCreds: 'Incorrect email or password',
    errDisabled: 'Account suspended. Contact your admin.',
    mustChangePwd: 'Please change your initial password first (Settings → Account)', errGeneric: 'Sign-in failed, please retry',
    // Self-service signup + email verification
    toRegister: 'Create account', toLogin: 'Back to sign in',
    teamName: 'Team name', teamNamePlaceholder: 'Enter a team name',
    usernamePlaceholder: 'Username (optional, for identification)',
    confirmPassword: 'Confirm password', confirmPasswordPlaceholder: 'Re-enter password',
    signUp: 'Sign Up', signingUp: 'Signing up…',
    errTeamName: 'Please enter a team name', errPwdShort: 'Password must be at least 8 characters', errPwdMismatch: 'Passwords do not match',
    registerOk: 'Account created. Please check your email to verify your address.',
    registerOkNoEmail: 'Account created, but the verification email failed to send. You can resend it from the sign-in page.',
    verifyTitle: 'Email Verification', verifying: 'Verifying…',
    verifyOk: 'Email verified. You can now sign in.', verifyFail: 'This verification link is invalid or expired.',
    goLogin: 'Go to sign in',
    notVerified: 'Please verify your email first (you can resend from the sign-in page).',
    // Forgot password / reset password
    forgotPwd: 'Forgot password?', forgotTitle: 'Reset Password', forgotSub: 'Enter your registered email and we will send a reset link',
    sendReset: 'Send reset link', sendingReset: 'Sending…',
    forgotOk: 'If that email is registered, a reset link has been sent (valid for 30 minutes).',
    resetTitle: 'Set New Password', resetSub: 'Choose a new password',
    newPassword: 'New password', newPasswordPlaceholder: 'Enter a new password (min 8 characters)',
    confirmNewPassword: 'Confirm new password', confirmNewPasswordPlaceholder: 'Re-enter new password',
    submitReset: 'Reset password', submittingReset: 'Resetting…',
    resetOk: 'Password reset. Please sign in with your new password.', resetFail: 'This reset link is invalid or expired.',
    backToLogin: 'Back to sign in',
  },
  ads: {
    ...adsExtra.en,
    title: 'Ad Accounts',
    accountCount: '{n} accounts',
    account: 'Account',
    balance: 'Unbilled',
    unbilledTip: 'Unbilled FB charges: spend not yet invoiced — NOT spendable credit (resets to 0 after each invoice)',
    availTip: 'How much you can still spend = spend cap − lifetime spend (converted to USD); accounts without a cap are exempt from low-balance alerts',
    availableCredit: 'Available Credit',
    spend: 'Spend',
    conversions: 'Conv.',
    activeToken: 'Active Token',
    custom: 'Custom',
    query: 'Query',
    loadAccounts: 'Load Accounts', syncCampaigns: 'Sync Ads', syncBgStarted: 'Syncing in the background; the list refreshes automatically in about 1-2 minutes',
    batchSyncNoToken: 'None of the selected accounts have a bound token',
    selected: '{n} selected',
    batchSync: 'Batch Sync',
    batchRemove: 'Batch Remove from Management',
    warmupArm: 'Enable Keepalive',
    warmupDisarm: 'Disable Keepalive',
    warmupShort: 'Keepalive',
    kaActiveAd: 'Keepalive on', kaHasSpend: 'Has spend·no keepalive', kaBurnt: 'Keepalive halted', kaFailed: 'Keepalive failed',
    kaBadgeClickTip: 'Keepalive halted/failed — click to designate a keepalive page and retry',
    kaPageMenu: 'Keepalive page', kaNowMenu: 'Keep alive now', kaPageTitle: 'Designate Keepalive Page',
    kaPageAuto: 'Auto-pick (default)', kaPageAutoHint: 'Try pages with ad permission under the writable token in order',
    kaPageAdvOk: '✓ Can advertise', kaPageAdvNo: '⚠ No ad permission (FB will reject)', kaPageFans: 'fans',
    kaPageNone: 'The writable token cannot access any page for this account', kaPageHint: 'The page must match the one bound at account creation, or FB will reject it. Ask your account provider for the bound page.',
    kaPageFix: 'Set page', kaPageClearBtn: 'Clear',
    kaPageSaved: 'Keepalive page saved', kaPageCleared: 'Designation cleared (back to auto-pick)',
    kaPageSaveRetry: 'Save & retry', kaRetrying: 'Retrying…', kaRetrySuperOnly: 'Single-account retry is superadmin-only — saved; the next daily scan will retry automatically',
    kaRetryOk: 'Keepalive ad created', kaRetrySkip: 'Skipped', kaRetryFail: 'Retry failed',
    warmupBadgeTip: 'Keepalive on: idle accounts get a tiny ad to stay active (guard/sentinel still run; stop-loss unaffected)',
    unnamedAccount: 'Unnamed account',
    openAdManager: 'Open in Ad Manager',
    unbound: 'Unbound',
    tokenOk: 'Available',
    tokenAbnormal: 'Abnormal',
    rotatingToken: 'Rotating tokens: {aliases}',
    poolTooltip: 'Pool of {n} tokens',
    viewInManager: 'View in Ad Manager', viewLandingLogs: 'View landing page logs',
    syncStatusBalance: 'Sync status/balance',
    removeManaged: 'Remove from management',
    emptyTitle: 'No ad accounts managed yet',
    emptyStep1: '① First go to', emptyStep1Tt: 'Go to', emptyLinkTt: 'Tokens page to connect TikTok',
    emptyLink: 'Facebook Auth',
    emptyStep1b: 'to bind a token',
    emptyStep2: '② Come back here and click "Load Accounts" to import',
    noLoadable: 'No loadable accounts (bind a Facebook token or connect TikTok on the Tokens page first)',
    loadDegraded: '⚠ These tokens failed to load (possibly rate-limited); accounts under them are not listed: {names} — reopen this dialog later',
    runKeepalive: 'Run keepalive',
    importedTag: 'Imported',
    importableTag: 'Importable',
    importing: 'Importing…',
    importSelected: 'Import Selected',
    selectAccountsFirst: 'Select accounts first',
    selectToImport: 'Select accounts to import',
    noBoundToken: 'This account has no bound token',
    batchRemoveConfirm: 'Remove {n} accounts from management? Their ads keep spending; stop-loss/sentinel/emergency-pause stop covering them immediately (history kept)',
    batchWarmupConfirm: 'Confirm {act} for {n} accounts? This batch-updates keepalive-list status.', kaArmOn: 'arm keepalive list', kaArmOff: 'remove from keepalive list',
    removeConfirm: 'Remove "{name}" from management? Its ads keep spending; stop-loss/sentinel/emergency-pause stop covering it immediately (history kept)',
    removed: 'Removed {n} accounts',
    removedSimple: 'Removed',
    refreshed: 'Refreshed {n} accounts',
    refreshedSimple: 'Refreshed',
    imported: 'Imported {n} ({skipped} already existed skipped)',
    idCopied: 'ID copied: {id}',
    copyFail: 'Copy failed, please select manually',
    syncing: 'Syncing {done}/{total}…',
    batchSyncResult: 'Success {ok} / Failed {fail}:\n\n{errs}',
    batchRemoveResult: 'Removed {ok} / Failed {fail}:\n\n{errs}',
    batchSyncFailDetail: 'Batch sync failure details',
    warmupToggled: '{label} {n} accounts',
    balLimited: 'Limited',
    balUnlimited: 'Unlimited',
    balHighLimited: 'High-Limited',
    opFailMsg: 'Failed: {msg}',
    searchPh: 'Search name / ID',
    noMatch: 'No matching accounts',
  },
  tokens: {
    assetTokens: 'Tokens', assetPages: 'Pages', assetBm: 'BM Assets', pageTitle: 'Tokens',
    statusCount: '{ok} active · {off} unavailable',
    loadFail: 'Failed to load',
    openDetailTip: 'Click to view token details (accounts / pages / BM / permissions)',
    closeLoadConfirm: '{n} account(s) are checked but not imported yet. Close and lose the selection?',
    oauthSuccess: 'Facebook authorization succeeded, token imported',
    oauthFail: 'Authorization failed: {msg}',
    abnormal: 'Abnormal',
    abnormal0: 'Abnormal',
    typeOperate: 'Writable',
    typeOperateTitle: 'Writable: write ads + read + can pause',
    typeManage: 'Manage',
    typeManageTitle: 'Manage: read + can pause, no new ads',
    typeUser: 'Read-only',
    typeUserTitle: 'Read-only: view only, no write/pause',
    sourceManual: 'Manual',
    justNow: 'just now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    copiedId: 'Copied {id}',
    copyFail: 'Copy failed, please select manually',
    refreshAll: 'Refresh all',
    checkingProgress: 'Checking {done}/{total}…',
    refreshAllResult: 'Done: {ok} normal, {fail} abnormal',
    refreshAllResultWarn: '(abnormal marked red, click detail to view)',
    refreshing: 'Refreshing…',
    accountsRefreshed: 'Refreshed {n} accounts',
    refreshFail: 'Refresh failed: ',
    unmanageWarning: '⚠ After removal their ads keep spending; stop-loss/sentinel/emergency-pause stop covering this account.', unmanageAdsLeft: ' ({n} ACTIVE ads were still running at removal)', unmanageConfirm: 'Remove "{name}" from management? This account will no longer be managed (token permissions unchanged, still exists on FB, can re-import anytime).',
    unmanaged: 'Removed from management',
    updated: 'Updated',
    updateFail: 'Update failed',
    assetReadPartial: 'Partial asset read failed: {msg}',
    assetReadPartialShort: 'Partial asset read failed: ',
    assetReadFail: 'Read failed',
    unknown: 'Unknown',
    userAssets: 'user assets',
    fetchFail: 'Fetch failed: ',
    importedCount: 'Imported {n}',
    skippedExisting: 'Skipped existing {n}',
    notFound: 'Not found {n}', readonlyRejected: '{n} account(s) ({names}) are not authorized for ads and were NOT imported — grant the token the ad role in Facebook Business Manager, then import again',
    notFoundTitle: 'Some IDs not recognized',
    notFoundDetail: '{n} not found: {ids} — double-check the IDs, or make sure the accounts are assigned to one of the bound tokens.',
    importFail: 'Import failed: ',
    selectUnimported: 'Select unimported accounts',
    pasteIds: 'Paste account IDs',
    deleted: 'Deleted',
    startOAuthFail: 'Failed to start authorization: ',
    oauthUrlTitle: 'Facebook OAuth URL',
    copyOAuthUrl: 'Copy auth link', openInBrowser: 'Open in this browser',
    oauthLinkCopied: 'Auth link copied (valid for 30 minutes) — paste it in another device/browser logged into Facebook',
    oauthPickHint: 'Authorize in this browser, or copy the auth link to another device logged into Facebook; the token imports automatically after authorization.',
    fillToken: 'Fill token',
    importedOk: 'Success',
    updateTokenPrompt: 'Paste the new personal access token:',
    updateTokenTitle: 'Update token · {name}',
    updateBtn: 'Update',
    tokenTooShort: 'Token too short',
    tokenUpdated: 'Token updated ({name})',
    checking: 'Checking…',
    checkFail: 'Check failed',
    deleteTokenConfirm: 'Delete "{name}"? All linked accounts will be unbound — inspection/stop-loss/sentinel stop covering them until a token is re-authorized.',
    connectFacebook: 'Connect Facebook',
    importAccounts: 'Import accounts',
    atRiskSummary: '{n} accounts lack an available token, read/write unavailable',
    collapse: 'Collapse ▲',
    viewDetail: 'View ▼',
    prevBound: 'was bound to {name}',
    unboundToken: 'No token bound',
    unbound: 'Unbound',
    fbUser: 'FB User', createdBy: 'Owner',
    colAccounts: 'Accounts',
    colPages: 'Pages',
    type: 'Type',
    unnamed: 'Unnamed',
    accountsCountTip: 'Imported account count',
    rotatePoolTip: 'Part of multi-token rotation candidate pool',
    checkValidity: 'Check validity',
    updateKey: 'Update token',
    refreshAccounts: 'Refresh accounts',
    deleteToken: 'Delete token',
    emptyTitle: 'No Facebook token bound yet',
    emptyStep: 'Click "Add token" or "Connect Facebook" above to start — bind first to load ad accounts and run guard.',
    emptyStep1: 'Connect a Facebook token (OAuth or paste manually)',
    emptyStep2: 'Load ad accounts (select and import to manage)',
    emptyStep3: 'Dashboard data flows in; guard and stop-loss start running',
    importThisToken: 'Import this token\'s accounts', importGlobalTitle: 'Import accounts · all tokens', importScopedTitle: 'Import accounts · {name}',
    tokenName: 'Token name',
    typeSource: 'Type / Source',
    lastVerified: 'Last checked',
    consecutiveFails: 'Consecutive failures',
    times: '×',
    linkedAccounts: 'Linked accounts',
    importedUnit: '(imported)',
    permCount: 'Permissions',
    items: 'items',
    tabAccounts: 'Ad accounts',
    tabPages: 'Pages',
    tabPerm: 'Permission detail',
    tokenWarn: '⚠ This token is currently unavailable ({status}), its accounts cannot be read/written — try checking the token, or re-import with an available token.',
    addAccount: 'Add account',
    clickToCopy: 'Click to copy',
    balanceLabelTip: 'Available = spend cap − lifetime spend; "No limit" = no spend cap set',
    unmanage: 'Remove from management',
    noImportedAccounts: 'No imported accounts — click "Import accounts" above to load',
    fans: 'fans',
    renameBtn: 'Rename', categoryBtn: 'Change Category', categoryPh: 'Search or type a category', pageCategoryPrompt: 'New page category (e.g. "Internet Marketing Service"). Requires page manage permission.', pageCategoryLimit: '1-120 chars', pageCategorySaved: 'Page category updated',
    maxAccountsBtn: 'Account Cap', maxAccountsPrompt: 'Max accounts this token may bind (currently {n} bound, limit: {cur}). Empty = unlimited. Writable tokens advised ≤100; too many accounts slow down inspection.', maxAccountsLimit: 'Empty or 1-5 digits', maxAccountsUnlimited: 'unlimited',
    importBigBatchConfirm: 'You are about to import {n} accounts — large batches increase inspection time and API call volume, and writable token caps may skip some. Continue?',
    skippedOverLimit: '{n} accounts skipped due to token binding cap (raise the cap or use another token)',
    readonlyTitle: 'BM-readable only',
    pageRenamePrompt: 'New page name (renames the real Facebook page)',
    pageRenameLimit: 'Name must be 1-100 characters',
    pageRenamed: 'Page renamed',
    changeTypeBtn: 'Switch token type',
    tokenTypeConfirm: 'Switch this token from "{from}" to "{to}"? Ad creation / stop-loss will then run via writable tokens.',
    tokenTypeSaved: 'Token type switched',
    ttmanage: 'Manage', ttoperate: 'Writable',
    noPages: 'No pages',
    viewMembersBtn: 'View members',
    manageAssetsBtn: 'Manage assets',
    bmMemberNoTitle: '(no title)',
    bmFull: 'Full control', bmEmployee: 'Employee',
    bmNoMembers: 'No viewable members (BM admin rights required)',
    bmNoAccounts: 'No viewable ad accounts under this BM',
    bmOwned: 'BM owned', bmClient: 'Client', bmManaged: 'Managed',
    bmPagesLine: 'Plus {n} pages',
    noBM: 'No BM',
    bmFullControl: 'Full control',
    permDetailTitle: 'Permissions ({n})',
    userId: 'User ID',
    tabChecklist: 'Checklist',
    tabIdImport: 'ID import',
    searchAccountPlaceholder: 'Fuzzy search: account name or ID',
    loadableMeta: '{total} manageable accounts, {selected} selected',
    importedMark: 'Imported', prevManagedMark: 'Previously managed · restorable',
    tokenAvailable: 'This token is available',
    tokenUnavailable: 'This token is unavailable (cooldown/throttled)',
    noMatchAccounts: 'No matching accounts',
    importSelected: 'Import selected',
    idImportHint: 'Paste account IDs, one per line or separated by comma/space.',
    idImportScopedHint: 'Recognized only under token "{name}".',
    idParseLine: 'Detected {n} · {m} after dedup',
    idParseDedup: '{k} duplicate(s) removed',
    idParseTooMany: 'Over 200 IDs — please import in smaller batches',
    tabOauth: 'OAuth',
    tabManual: 'Personal token',
    oauthHint: 'Add an App in "Configure App" first.',
    systemApp: 'System', primaryApp: 'Primary',
    myApp: 'Mine',
    manualWarn: '⚠ Cannot auto-renew, OAuth recommended.',
    accessTokenPlaceholder: 'Access Token',
    aliasOptional: 'Name (optional)',
    optOperate: 'Writable (write ads + read + can pause)',
    optManage: 'Manage (read + can pause, no new ads)',
    optUser: 'Read-only (view only, cannot pause)',
    scopeAdsManagement: 'Ads Management',
    scopeAdsRead: 'Ads Read',
    scopePagesShowList: 'Pages Show List',
    scopePagesMessaging: 'Pages Messaging',
    scopePagesManageMetadata: 'Pages Manage Metadata',
    scopePagesReadEngagement: 'Pages Read Engagement',
    scopePagesManagePosts: 'Pages Manage Posts',
    scopePagesReadUserContent: 'Pages Read User Content',
    scopePagesManageEngagement: 'Pages Manage Engagement',
    scopePagesEvents: 'Pages Events',
    scopeBusinessManagement: 'Business Management',
    scopeReadInsights: 'Read Insights',
    scopeInstagramBasic: 'Instagram Basic',
    scopeInstagramManageInsights: 'Instagram Manage Insights',
    scopeInstagramManageComments: 'Instagram Manage Comments',
    scopePublicProfile: 'Public Profile',
    scopeEmail: 'Email',
    scopeAttributionRead: 'Attribution Read',
    scopeCatalogManagement: 'Catalog Management',
    scopeWhatsappBusinessManagement: 'WhatsApp Business Management',
    scopeLeadsRetrieval: 'Leads Retrieval',
    scopePagesManageCta: 'Pages Manage CTA',
    dataHealth: 'Data Health',
    healthTitle: 'Token / Account Data Health',
    healthMeta: 'Scanned {creds} tokens · {accounts} accounts · {links} links · {th} health records · TikTok tokens {ttc} / TikTok links {ttl}',
    healthLoadFail: 'Data health scan failed',
    healthAllClean: 'No abnormal data found',
    healthCleanBtn: 'Clean Invalid Links',
    cleaning: 'Cleaning…',
    cleanConfirm: 'This will clean up invalid token link records and token health records (safe to re-run). Tokens and accounts themselves are never deleted. Proceed?',
    cleanDone: 'Clean done: {afc} invalid links · {th} health records deleted · {cred} primary tokens reset · {tt} token types fixed · {ttc} TikTok links deleted · {ttp} TikTok primary tokens reset',
    hCleanable: 'cleanable',
    hManualOnly: 'report-only',
    hIssueCredBadStatus: 'Token status value abnormal',
    hIssueCredBadTokenType: 'Token type value abnormal',
    hIssueAccountDanglingCred: 'Account primary token deleted or unavailable',
    hIssueAfcDangling: 'Token link record invalid (account or token deleted)',
    hIssueAfcTenantMismatch: 'Link record belongs to the wrong team',
    hIssueAfcBadStatus: 'Link record status value abnormal',
    hIssueTokenHealthDangling: 'Token health record invalid (token deleted)',
    hIssueAccountEmptyActid: 'Account ID missing',
    hIssueTtCredBadStatus: 'TikTok token status value abnormal',
    hIssueTtAccountDanglingCred: 'Account TikTok primary token deleted or unavailable',
    hIssueTtcDangling: 'TikTok token link record invalid or wrong team',
    hIssueTtcBadStatus: 'TikTok link record status value abnormal',
    // TikTok section
    connectTikTok: 'Connect TikTok',
    ttLoadFail: 'Failed to load TikTok tokens',
    ttStartFail: 'Failed to start TikTok OAuth: ',
    ttEmptyTitle: 'No TikTok token yet',
    ttEmptyHint: 'Click "Connect TikTok" to authorize; all ad accounts under the granted advertisers are imported automatically.',
    ttAutoNote: 'The access token expires in 24h and is auto-refreshed every 6 hours; the refresh token lasts 365 days, with a re-auth reminder 30 days before expiry.',
    ttAccessExpires: 'Access expires',
    ttExpiredNow: 'Expired',
    ttInHours: '{n}h',
    ttInMinutes: '{n}m',
    ttLastRefresh: 'Auto-refreshed',
    ttRefreshLeft: 'Refresh left',
    ttDaysUnit: '{n} days',
    ttReauth: 'Re-authorize',
    ttReauthTip: 'The refresh token expires within 30 days. Re-authorize soon - after expiry auto-renewal stops.',
    ttLinkedAccounts: 'Accounts',
    ttAppTitle: 'TikTok App Configuration',
    ttAppHint: 'System-level App, configured once by the superadmin and shared by all teams. Current App ID: {appId}',
    ttAppNotConfigured: 'Not configured',
    ttAppIdPh: 'App ID',
    ttAppSecretPh: 'App Secret',
    ttAppSave: 'Save',
    ttAppSaved: 'Saved',
    ttAppFillBoth: 'Both App ID and App Secret are required',
    ttAppsTitle: 'TikTok App', ttAddApp: 'Add App', ttAppNamePh: 'App name (optional)',
    ttNoAppsSuper: 'No TikTok App configured yet — click "Add App" and fill in the App ID / Secret from the developer portal', ttNoAppsGoSettings: 'No apps yet — admin adds them in Settings → App configuration',
    ttNoAppsUser: 'No TikTok App configured yet. Please contact the platform administrator.',
    ttAppDeleteConfirm: 'Delete app "{name}"? (Existing tokens keep working; no new authorization can be started)',
    ttLoadHint: 'Only TikTok accounts that are authorized but not yet managed are listed; check them to import.',
    ttNoLoadable: 'No loadable accounts (connect TikTok first)',
    ttCoverToken: 'Authorized token',
    ttImportedGoAds: 'Imported {n} TikTok account(s). Go to the Ad Accounts page?',
    fbImportedGoAds: 'Imported {n} account(s). Go to the Ad Accounts page?',
    goAdsPage: 'Go to Ad Accounts',
    ttRefreshNow: 'Refresh now',
    ttRefreshedNow: 'Refreshed; the access token expires in about {h} hours',
    ttRefreshFail: 'Refresh failed: ',
    ttDeleteConfirm: 'Delete TikTok token "{name}"?',
    ttDeleteWarning: 'Linked TikTok accounts are kept (unbound, no longer auto-renewed); re-authorize to bind again.',
  },
  audit: {
    tabAll: 'All',
    tabUser: 'Actions',
    tabSystem: 'System',
    tabLogin: 'Login',
    tabFail: 'Failed',
    fieldAction: 'Action',
    actionPlaceholder: 'Select or type an action',
    actionKeepaliveBurnt: 'Keepalive paused', actionBudgetProgress: 'Budget progress alert', actionWarmupDisarm: 'Removed from keepalive', actionStaleAccounts: 'Stale accounts flagged', actionSubcodeCleanup: 'Subcode cleanup', actionAssign: 'Assign', actionUnassign: 'Unassign', actionAllowance: 'Whitelist', actionAllowanceRemoved: 'Whitelist removed', actionEmergencyPause: 'Emergency pause', actionPurgeStalePages: 'Stale pages cleanup', actionKeepaliveSetPage: 'Set keepalive page', actionSetMaxAccounts: 'Set binding cap', actionPageHealth: 'Page health check', actionPageUnavailable: 'Page unavailable alert', actionAiQuota: 'AI quota exhausted', actionAdjust: 'Balance adjustment', actionCreatePixel: 'Pixel created', actionStormSuppressed: 'Alerts merged', actionPruneHashCache: 'Asset cache cleanup', actionTokenHealthWarn: 'Token health warning', actionManualBudget: 'Manual budget change', actionUpsert: 'Save', metaAct: 'Account', metaAd: 'Ad', metaPage: 'Page', metaCred: 'Token', metaCampaign: 'Campaign', metaTeam: 'Team', metaOld: 'Old', metaNew: 'New', metaReason: 'Reason', metaBudget: 'Budget', metaSpend: 'Spend', metaBalance: 'Balance', metaCount: 'Count', metaPagesMismatch: 'Pages mismatched', metaStatus: 'Status', metaTemplate: 'Template', metaJob: 'Job', metaSlug: 'Subcode', actionImport: 'Import accounts',
    fieldUser: 'User',
    fieldTrace: 'Trace',
    tracePlaceholder: 'trace_id to pull full chain',
    fieldDate: 'Date',
    dateStart: 'Start',
    dateEnd: 'End',
    clear: 'Clear',
    pagerInfo: '{total} items · page {page} / {pages}',
    prevPage: 'Prev',
    nextPage: 'Next',
    jumpPh: 'Page #',
    jumpGo: 'Go',
    traceLabel: 'Trace',
    traceCount: '{n} items',
    traceEmpty: 'No more records for this trace',
    colTime: 'Time',
    colType: 'Type',
    colAction: 'Action',
    colTarget: 'Target',
    colTeam: 'Team',
    colResult: 'Result',
    resultSuccess: '✓ Success',
    resultFail: '✗ Failed',
    typeUser: 'User',
    typeSystem: 'System',
    typeSentinel: 'Sentinel',
    typeSync: 'Sync',
    typeWarmup: 'Keepalive',
    actionInspectionHeartbeat: 'Inspection Heartbeat',
    actionPause: 'Pause',
    actionDeploy: 'Ad Deploy',
    actionLogin: 'Login',
    actionSwitchTenant: 'Switch Team',
    actionAccountPermissionError: 'Token Permission Denied',
    actionTokenRateLimited: 'Token Rate Limited',
    actionLandingHealthAlert: 'Landing Health Alert',
    actionCoverageLost: 'Coverage Lost',
    actionCreate: 'Create',
    actionUpdate: 'Update',
    actionDelete: 'Delete',
    actionArchive: 'Archive',
    actionRulePause: 'Rule Pause',
    actionSentinelPause: 'Sentinel Pause',
    actionEmergencyPause: 'Emergency Pause',
    actionTokenExpired: 'Token Expired',
    actionTokenInvalid: 'Token Invalid',

    // Batch CD: full i18n for log action/target/source enums (as seen in prod)
    actionKeepalive: 'Keepalive ad', actionOrphanAccountAlert: 'Orphaned account alert', actionLowBalanceAlert: 'Low balance alert',
    actionRulePauseNotified: 'Rule pause notified', actionLiveFetchDegraded: 'Fetch degraded', actionAccountStatusChange: 'Account status change',
    actionInspectionStalledAlert: 'Inspection stalled alert', actionManualPaused: 'Manual pause', actionManualActive: 'Manual activate',
    actionGroupUpdate: 'Ad set update', actionAiAnalyze: 'AI analysis', actionAiEdit: 'AI copy edit',
    actionSentinelFailureAlert: 'Sentinel failure alert', actionSentinelArm: 'Sentinel arm', actionSentinelDisarm: 'Sentinel disarm',
    actionSentinelAutoArmed: 'Sentinel auto-armed (inactivity timeout)', actionSentinelAutoArmWarning: 'Sentinel countdown warning',
    actionSentinelPermDenied: 'Sentinel permission denied', actionSentinelBatchAlert: 'Sentinel batch alert',
    actionUnmanage: 'Unmanage', actionHardDelete: 'Delete permanently', actionWarmupArm: 'Enable keepalive',
    actionInspectionSkipped: 'Inspection skipped', actionUpdateToken: 'Token update', actionUpload: 'Upload',
    actionRename: 'Rename', actionSyncStalled: 'Sync stalled', actionRestore: 'Restore', actionSpendSpike: 'Spend spike',
    targetTenant: 'Team', targetAsset: 'Asset', targetCampaign: 'Campaign', targetSystemSetting: 'System setting',
    targetSync: 'Sync job', targetLandingTemplate: 'Landing page template', targetAudience: 'Audience', targetLead: 'Lead', targetPage: 'Page',
    sourceAccountSync: 'Account sync', sourceCfApi: 'Domain service', sourceKeepalive: 'Keepalive engine', sourceAdOps: 'Ad ops',
    sourceAuth: 'Auth', sourceAiVision: 'AI vision', sourceAdsCacheSync: 'Ads cache sync', sourceAdmin: 'Admin console',
    sourceEmergencyPause: 'Emergency pause', sourceKpiResolver: 'KPI resolver', sourceSentinelPatrol: 'Sentinel patrol',

    targetScheduler: 'Scheduler',
    targetAd: 'Ad',
    targetAccount: 'Account',
    targetFbCredential: 'Token',
    targetLandingPage: 'Landing Page',
    targetLaunchTemplate: 'Launch Template',
    targetLaunchJob: 'Launch Job',
    targetFormTemplate: 'Form Template',
    targetUser: 'User',
    targetTeam: 'Team',
    targetSubcode: 'Subcode',
    targetRule: 'Rule',
    sourceScheduled: 'Scheduled Task',
    sourceRuleEngine: 'Rule Engine',
    sourceFbApi: 'FB API',
    sourceGuard: 'Rule Engine',
    sourceLanding: 'Landing',
    sourceLaunch: 'Ad Deploy',
    sourceSentinel: 'Sentinel',
    sourceWatchdog: 'Task Monitor',
    sourceUser: 'User Action',
    sourceWarmup: 'Keepalive',
    sourceSync: 'Data Sync',
  },
  members: {
    tabMembers: 'Team Members',
    tabRoles: 'Roles & Permissions',
    memberCount: '{n} members',
    inviteMember: 'Invite Member',
    colMember: 'Member',
    colRole: 'Role',
    you: 'You',
    permCount: '{n} perms',
    roleCount: '{n} roles',
    createRole: 'New Role',
    systemTag: 'System',
    permCountLabel: '{n} permissions',
    memberCountLabel: '{n} people',
    editPerms: 'Edit Permissions',
    noPerms: 'No permissions',
    editRole: 'Edit Role',
    roleName: 'Role name',
    roleNamePlaceholder: 'e.g. Landing Specialist',
    description: 'Description',
    descriptionPlaceholder: 'Role description (optional)',
    permMatrixTitle: 'Permission matrix (check modules this role can use)',
    selectedPerms: '{n} permissions selected',
    email: 'Email',
    emailPlaceholder: 'New member email',
    password: 'Password',
    passwordPlaceholder: 'Leave blank = default Welcome123!',
    inviting: 'Inviting…',
    invite: 'Invite',
    loadFail: 'Failed to load',
    roleNameRequired: 'Enter role name',
    roleUpdated: 'Role updated',
    roleCreated: 'Role created',
    systemRoleNoDelete: 'System role cannot be deleted',
    roleHasMembers: 'This role has members, transfer them first',
    delRoleConfirm: 'Delete role "{name}"?',
    doneSuffix: 'deleted',
    emailRequired: 'Enter email',
    invitedWithPwd: 'Invited, default password: {pwd} (please ask them to change it after first login)',
    invited: 'Invited',
    inviteSuccess: 'Invitation sent',
    roleChange: 'Role change',
    changeRoleFromOwner: 'Change {email} from [Owner] to [{role}]?\n\nDowngrading an owner immediately revokes their admin permissions (rules/config/invites).',
    changeRole: 'Change {email}\'s role to [{role}]?',
    removeMemberConfirm: 'Remove member "{email}"?', resetPwd: 'Reset password', resetPwdConfirm: 'Issue a new temporary password for {email}? The old one stops working immediately; the member must change it at first login.', resetPwdDone: 'New temporary password: {pwd} — copy and send it to the member now (this dialog will not show again)',
    removed: 'Removed',
    deleted: 'Deleted',
    perm: {
      adsRead: 'View Ads',
      adsCreate: 'Create Ads',
      adsPause: 'Pause Ads',
      adsResume: 'Resume Ads',
      adsUpdate: 'Update Ads',
      adsDelete: 'Delete Ads',
      rulesRead: 'View Rules',
      rulesCreate: 'Create Rules',
      rulesEdit: 'Edit Rules',
      landingManage: 'Ad Links',
      assetsManage: 'Asset Library',
      billingView: 'View Billing',
      billingManage: 'Manage Billing',
      membersInvite: 'Invite Members',
      membersManage: 'Manage Members',
      auditRead: 'Audit',
    },
  },
  settings: {
    pageTitle: 'Settings', pageMeta: 'Account · Notifications · Schedule · System',
    tzShanghai: 'Beijing/Shanghai', tzHongKong: 'Hong Kong', tzTaipei: 'Taipei', tzTokyo: 'Tokyo',
    tzSeoul: 'Seoul', tzSingapore: 'Singapore', tzBangkok: 'Bangkok', tzJakarta: 'Jakarta',
    tzMumbai: 'Mumbai', tzLosAngeles: 'Los Angeles', tzNewYork: 'New York', tzSaoPaulo: 'São Paulo',
    tzLondon: 'London', tzParis: 'Paris', tzSydney: 'Sydney',
    tzSwitched: 'Switched. All times now show in this timezone.',
    copyFailManual: 'Copy failed, please select and copy manually.',
    saveFail: 'Save failed: {msg}',
    taskInspect: 'Inspection (stop-loss eval)', taskWatchdog: 'Token health check',
    taskAccountSync: 'Account status / balance', taskBudget: 'Budget progress alert',
    taskReassociate: 'Re-bind stale accounts', taskSubcode: 'Subcode auto-bind', taskSentinel: 'Sentinel patrol',
    sentinelChangeMsg: 'Sentinel patrol interval will change to {n} minutes. Confirm?',
    sentinelChangeTitle: 'Sentinel interval change',
    baseChangeMsg: 'Change base interval to {n} minutes? This is the frequency base for all scheduled tasks (inspection/budget/task monitoring, etc.) and globally affects stop-loss/alert response speed.',
    baseChangeTitle: 'Base interval change', confirmChange: 'Confirm change',
    aiPresetGemini: 'Gemini (OpenAI-compatible)', noChange: 'No changes',
    textModelOk: 'Text model: {detail}', textModelFail: 'Text model failed: {detail}', testFail: 'Test failed',
    visionModelOk: 'Vision model: {detail}', visionModelFail: 'Vision model failed: {detail}',
    invalidEmail: 'Enter a valid email', fillOldPwdForEmail: 'Enter your current password to confirm the email change', emailUpdated: 'Username updated. Use the new email to log in next time.',
    opFail: 'Failed: {msg}',
    fillOldNewPwd: 'Enter old / new password', pwdMismatch: 'The two new passwords don\'t match', pwdMinLen: 'New password must be at least 8 characters',
    pwdUpdatedRelogin: 'Password updated. Please log in again with the new password.',
    tgBindOk: 'TG bound: {name}', tgBindFail: 'TG binding failed',
    tgTestSentUser: 'Test message sent to your TG', sendFail: 'Send failed',
    tgTestSentTenant: 'Test message sent to team TG', tgTestFailTenant: 'Send failed (admin has not bound a team TG)',
    fillChatId: 'Enter chat_id', bound: 'Bound', bindFail: 'Binding failed',
    tgUnbindConfirm: 'Unbind TG? You will no longer receive TG alert notifications after unbinding.', tgUnbound: 'Unbound',
    fxUpdated: 'Updated exchange rates for {n} currencies', fetchFail: 'Fetch failed: {msg}',
    retentionShrinkItem: '{label} {from}→{to} days',
    retentionShrinkMsg: 'The retention days below were reduced. The next cleanup (daily 4:33) will delete over-age records:\n{detail}\n\nConfirm?',
    retentionShrinkTitle: 'Retention tightened · data will be deleted', confirmShrink: 'Confirm tighten',
    retentionSaved: 'Retention policy saved (auto cleanup daily at 4:33)',
    retentionCleanItem: '{table}: {n} deleted', retentionCleanDone: 'Cleanup done · {detail}', cleanFail: 'Cleanup failed: {msg}', retentionRunTitle: 'Clean Data Now', retentionRunConfirm: 'Permanently delete expired data per current retention policy (landing logs / audit logs / patrol history) — irreversible. Proceed?', retentionRunBtn: 'Confirm clean',
    keepaliveEnabled: 'Keepalive enabled globally',
    kaRunNow: 'Scan now', kaRunHint: 'Scanning (10–60s); the result dialog opens when done', kaResultTitle: 'Keepalive Scan Result', kaBuilt: 'Built', kaSkipped: 'Skipped', kaFailed: 'Failed', kaSuccess: 'Success', kaSkip: 'Skip', kaFail: 'Fail', kaNoAccounts: 'No eligible accounts',
    accountTitle: 'Account',
    grpPersonal: 'Personal', grpPlatform: 'Platform', grpAutomation: 'Scheduling & Automation', grpIntegrations: 'AI & Integrations', grpBilling: 'Billing & Domains',
    accountDesc: 'Login username (email) and password. After changing the password you must log in again with the new one.',
    username: 'Username', loginEmailPh: 'Login email', saveUsername: 'Save username', acctEmailTitle: 'Change login email', changePwdTitle: 'Change password', displayNameTitle: 'Display name', displayNamePh: 'A friendly name (e.g. John); empty falls back to email prefix',
    oldPwd: 'Old password', currentPwdPh: 'Current password', newPwd: 'New password', pwdMin8Ph: 'At least 8 chars',
    confirm: 'Confirm', pwdMismatchPh: 'Don\'t match', reenterNewPwdPh: 'Re-enter new password', changePwd: 'Change password',
    tzTitle: 'System display timezone', tzDesc: 'Display timezone for all system times.',
    tzSearchPh: 'Search city or enter timezone name (e.g. Asia/Shanghai)', tzOption: '{label} ({tz})',
    scheduleTitle: 'Task schedule', scheduleDesc: 'Execution frequency of each automated task.',
    baseBeat: 'Base beat', minutes: 'minutes', taskCol: 'Task', multiplierCol: 'Multiplier', effectiveCol: 'Effective',
    minSuffix: '{n} min', saveAndApply: 'Save & apply',
    gtTitle: 'Inspection & alerts', gtDesc: 'Platform-wide parameters for stop-loss inspection and alerting. Apply to all teams.',
    gtParamCol: 'Parameter', gtValueCol: 'Current value', gtDescCol: 'Description',
    gtConc: 'Inspection concurrency',
    gtConcHint: 'Ad accounts inspected in parallel: larger = faster but more load. Default {d} (1-8).',
    gtLearn: 'Learning-period protection',
    gtLearnHint: 'Ads created less than N hours ago are not paused, giving the FB system a learning period. Default {d} hours. Enter 0 to disable.',
    gtStorm: 'Alert storm cap',
    gtStormHint: 'Max alerts per team per event type per day; anything beyond is silenced for the rest of the day to prevent spam. Default {d}. Enter 0 for no cap; effective within 1 minute after saving.',
    gtFillAll: 'All three parameters are required integers', gtRange: 'Must be an integer between {min} and {max}',
    aiTitle: 'AI config',
    aiDesc: 'AI services (copy / vision dual models).',
    aiTextModelTitle: 'Text model (KPI / copy generation)', provider: 'Provider',
    providerPh: 'Select provider or enter Base URL', providerOpt: '{label} ({url})',
    fillNewKeyPh: 'Enter new key to overwrite', modelPh: 'Select model or enter model name',
    aiVisionModelTitle: 'Vision model (asset AI recognition, images)',
    aiVisionDesc: 'Use a vision model like Gemini. DeepSeek is text-only and can\'t read images, so asset recognition is configured separately here.',
    testText: 'Test text', testVision: 'Test vision',
    cfTitle: 'Cloudflare',
    cfMainTitle: 'Tova system CF (main)',
    cfMainScope: 'system only',
    cfMainHint: 'Manages tovaads.com zone, email routing, frontend deploys and alphatx only — never touches landing pages (those go through the dedicated account below).',
    cfPermStep: 'Create token: CF Dashboard → My Profile → API Tokens → Create Token (Custom token), account = the dedicated landing account, permissions exactly as below:',
    cfPermAcc: 'Account',
    cfPermZone: 'Zone · All zones',
    cfPermOpt: 'Optional',
    cfPermNote: 'Names match the CF dashboard; "Zone — Edit" lives under the Zone section — set it to "All zones" (covers future domains). Paste the token, then hit "Test connection" — three green checks means ready.',
    cfLandingTitle: 'Landing CF account',
    cfLandingNotSet: 'Not configured — landing features unavailable',
    cfLandingActive: 'Active',
    cfLandingHint: 'All landing-page operations (domain zones / Pages deploys / subdomain binding / domain-shop zone creation) go through this dedicated account only — the main key never touches landing infrastructure. Unconfigured means a clear error, never a fallback.',
    cfLandingClear: 'Clear',
    cfLandingClearConfirm: 'Clear the landing CF configuration? Landing features will be unavailable until reconfigured.',
    cfTestBtn: 'Test connection',
    cfViewLabel: 'Console view',
    cfScopeMain: 'Main account',
    cfScopeLanding: 'Landing account',
    cfOnboardTitle: 'Onboard external domain', cfOnboardPh: 'A domain bought elsewhere, e.g. mybrand.com', cfOnboardBtn: 'Onboard',
    cfOnboardOk: 'Domain {d} added to CF — change the nameservers at your registrar to the two below (then refresh here until status turns active)',
    cfOnboardNsHint: 'At your registrar → DNS/Nameserver settings → replace with these CF nameservers (click to copy):',
    cfZonesTitle: 'Domains', cfPagesTitle: 'Pages projects', cfNoZones: 'No domains', cfNoRecords: 'No DNS records', cfLpLink: 'Linked landing page',
    pbTitle: 'Porkbun domains', pbDesc: 'Domain shop registrar credentials (porkbun.com → Account → API Access).', pbTest: 'Test', pbTestOk: 'Connected ({a})', pbHint: 'Once configured, Landing → Buy domain activates: pricing/order/register/CF onboarding fully automated.',
    rgPayMoved: 'Payment collection moved to its own Payment Settings section.', rgTitle: 'Domain registrar', rgDesc: 'Registrar for the domain shop: Dynadot (recommended — Alipay top-up, API spends from account balance) / Porkbun (USD card).', rgSelect: 'Active registrar', rgVerified: 'Verified ✓ {v}', rgUnverified: 'Saved · not verified (click Test)', rgReady: 'Configured', rgNoKey: 'No credentials', rgDdHint: 'Dynadot\'s new REST API uses a key pair: generate the "API Production Key" AND the "Secret" on Tools → API and fill in both (the Secret signs register/account calls). Prepay balance (Alipay supported) before registering.', rgSecretPh: 'The "Secret" — generated on the same page as the API Production Key', rgFee: 'Service fee (USD)', rgFeePh: 'Current ${v}; type to change', rgFeeFixed: 'Fixed', rgFeePercent: 'Percent+floor', rgFeeFixedAmt: 'Fixed fee ($)', rgFeeRate: 'Rate (%)', rgFeeRatePh: 'Current {v}%, type to change', rgFeeFloor: 'Floor ($)', rgFeeFloorPh: 'Current ${v}, type to change', rgFeeRuleHint: 'Percent mode: fee = max(floor, rate×cost) — cheap domains use the floor, expensive ones scale.', rgPayTitle: 'USDT payment (site-wide for now)', rgPayChain: 'Chain', rgPayChainPh: 'e.g. TRC20 / ERC20', rgPayAddr: 'Receiving address', rgPayAddrPh: 'One TRC20 address per line', rgPayAddrNewPh: 'One address per line; saving replaces (empty = keep)', payPoolPh: 'One address (TRC20) per line; saving replaces — leave empty to keep current', payPoolNote: '{n} receiving addresses, assigned to orders in order', payAddrChange: 'Change address', payShowQr: 'QR code', payHideQr: 'Hide QR', payTitle: 'Payment Settings', payDesc: 'Site-wide USDT-TRC20 collection. On-chain detection via TronGrid (official Tron API) — zero fees, no third-party gateway.', payReady: 'Receiving address set', payNoAddr: 'No receiving address', tgKeyPh: 'Get one free at trongrid.io', tgKeyHint: 'TronGrid API key is optional (lower rate limits without one); create it trongrid.io → Dashboard → API Keys.', payNoteLabel: 'Payment note (shown to customers)', payNotePh: 'e.g. note the domain when transferring', rgPayHint: 'Domain orders will show this address for USDT payment; admin confirms receipt.', rgFeeHint: 'Per-order service fee added in the domain shop, shown in suggestions and order totals.', rgDynadotKeyPh: 'Tools → API', rgTestOk: 'Connected ({a}{b})',
    cfAccountNsTip: 'Set registrar NS to these two (a domain may differ — the onboarding result is authoritative)', cfPendingHint: 'NS not active yet — check your registrar',
    cfUsageTitle: 'Usage & limits', cfToday: 'Today',
    cfLimitsLine: 'Free tier reference: static requests {a} · bandwidth {b} · Functions invocations {c}/day · builds {d}/month (higher on paid plans)',
    cfUnlimited: 'Unlimited', cf100k: '100K',
    cfPermHint: 'Analytics permission still missing (live CF check): needs {perm}. CF dashboard → My Profile → API Tokens → find the token ending in {tail} (the exact one) → Edit → add Zone › Analytics › Read (Zone-level, NOT Account-level) → Zone Resources: All zones → save, then click ⟳ to retry.', cfTokenTailTip: 'Last 6 chars of the CF API Token in use (edit THIS token)', cfUsageTotal: 'Total',
    cfUvRt: 'near real-time (minute granularity)', cfSparkTip: '30-day request trend (today excluded)',
    cfReconTitle: 'Domain Reconcile (CF ↔ library)', cfReconOk: 'All consistent ✓', cfReconCfOnly: 'zone in CF but not in the domain library', cfReconLibOnly: 'in the library but no CF zone',
    cfUvToday: 'Requests today · unique visitors (CF aggregates daily; today lags a few hours)',
    cfEmailTokenLabel: 'Email admin token (optional)', cfEmailTokenPh: 'User-level API token (cfat_ account tokens do not work)',
    cfTokenNameLabel: 'Token name (label)', cfTokenNamePh: 'e.g. Tovaads — match the CF dashboard token name for easy identification',
    cfEmailTokenHint: 'Email Routing address/rule management only supports user-level API tokens. CF dashboard -> My Profile -> API Tokens -> Create Token with Zone (tovaads.com): Email Routing Addresses Edit + DNS Edit + Zone Read. Leave empty if you only need enable/DNS.',
    emNeedUserToken: 'Warning: managing destination addresses / forwarding rules requires a user-level CF token — fill "Email admin token" in Domain service config, then refresh (enable & DNS are unaffected).',
    cfDesc: 'Platform domain service credentials.',
    emTitle: 'Email forwarding',
    emDesc: "Forward {domain} mailbox to your real inbox (CF Email Routing, fully automated).",
    resendTitle: 'Email sending',
    resendDesc: 'Sends system emails such as signup verification and password reset.',
    resendKeyLabel: 'Resend API Key', resendKeyPh: 'Generate at resend.com',
    resendReady: 'Configured', resendNoKey: 'Not configured',
    resendKeyHint: 'Register at resend.com and verify your sending domain, then generate an API Key for verification/reset emails.',
    resendTestToPh: 'Test recipient email', resendTest: 'Send test email',
    resendTestOk: 'Test email sent to {to}', resendTestToRequired: 'Enter a test recipient email', resendKeyRequired: 'Enter a Resend API Key',
    emStatusUnconfigured: 'Not enabled',
    emStatusEnabled: 'Enabled',
    emStatusDisabled: 'Disabled',
    emDnsReady: 'DNS ready',
    emDnsMissing: '{n} DNS records missing',
    emEnableBtn: 'Enable & auto-configure DNS',
    emFixDnsBtn: 'Fix missing DNS records',
    emEnabling: 'Enabling…',
    emEnabledMsg: 'Email Routing enabled, {n} DNS records added',
    emEnableHint: 'Enabling requires 3 MX + 1 SPF TXT records; existing DNS is compared and only missing ones are added.',
    emDestTitle: 'Destination addresses',
    emDestDesc: 'The real inbox mail is finally delivered to. CF sends a verification email after adding — open it and click the link before it can be used for forwarding.',
    emAddrPh: "you{'@'}example.com",
    emAddrInvalid: 'Invalid email address',
    emAddrAdded: 'Added — verification email sent. Open it in that inbox and click the link',
    emAddrExisted: 'This address was already added (see verification status above)',
    emAddrVerified: 'Verified',
    emAddrPending: 'Pending · click the verification email',
    emAddrDelConfirm: 'Delete destination address {email}? It cannot be deleted while referenced by a mapping.',
    emNoAddrs: 'No destination addresses yet',
    emRouteTitle: 'Forwarding mappings',
    emRouteDesc: "Domain alias → destination address. Alias accepts lowercase letters, digits and . _ - only (e.g. dev → dev{'@'}{domain}).",
    emAliasPh: 'Alias, e.g. dev',
    emAliasRequired: 'Enter an alias first',
    emPickDestPh: 'Pick a verified destination address',
    emDestRequired: 'Pick a destination address first',
    emRouteAdd: 'Add mapping',
    emRouteAdded: 'Mapping created — mail to this address is forwarded immediately',
    emRouteDelConfirm: 'Delete forwarding for {alias}? This address will no longer receive mail.',
    emNoRoutes: 'No mappings yet',
    emDeleted: 'Deleted',

    faTitle: 'App Config', faDesc: 'Platform app management (Facebook OAuth / TikTok connect).', faFbSubTitle: 'Facebook Apps', ttSubTitle: 'TikTok Apps (connect from the Tokens TikTok section)', ttAdd: '+ Add TikTok App', ttEmpty: 'No TikTok apps yet', ttAppIdPh: 'TikTok Sandbox / Production App ID', ttDefaultTag: 'Default', ttFillBoth: 'app_id and app_secret are required', ttDeleteConfirm: 'Delete TikTok app "{name}"? Tokens authorized with it will stop working.',
    faAdd: '+ New Facebook App', faAddTitle: 'New Facebook App', faName: 'Name', faNamePh: 'e.g. Main App', faAppId: 'App ID', faSecret: 'App Secret', faEditTitle: 'Edit Facebook App',
    faSecretKeep: 'Leave empty to keep current secret', faSystem: 'System', faSystemOpt: 'System app (shared, superadmin only)',
    faFillBoth: 'App ID and Secret are required', faDeleteConfirm: 'Delete App {id}? Tokens authorized with it cannot renew, and lead-push verification stops working.', faEmpty: 'No apps yet — create one below', faPrimary: 'Primary', faBackup: 'Backup', faSetPrimary: 'Set primary', faStop: 'Disable', faEnable: 'Enable', faInactive: 'Disabled', faStopConfirm: 'Disable App {name}? Existing tokens keep working; it just stops issuing new authorizations.', faStartConfirm: 'Enable App {name}?',
    ibTitle: 'Account Import Behavior', ibDesc: 'Central defaults for the load-accounts modal and token caps (superadmin).',
    ibAllLabel: 'Pre-select all unimported accounts in load modal', ibCapLabel: 'Default account cap for new writable tokens:',
    ibCapPh: '100', ibCapNote: 'Binding cap written to newly authorized operate tokens (0=unlimited). Existing tokens: adjust per-token via ⋯ menu.', ibCapLimit: 'Must be 0-10000',
    whTitle: 'FB Real-time Leads Push',
    whDesc: 'FB leads realtime push (verified via the configured App Secret).',
    whCopyUrl: 'Copy URL',
    whUrlCopied: 'Webhook URL copied',
    whActiveApps: '{n} App(s) configured (for push verification)',
    whTokenLabel: 'Verify Token (enter the same value when configuring the webhook in FB dashboard)',
    whTokenPh: 'Set Verify Token',
    whTokenHint: 'Enter a new value to override (a strong random value is recommended); leave empty + save to restore default. Takes effect immediately.',
    whTokenReset: 'Restored to default',
    whDefault: 'default',
    whCustom: 'custom',
    whResetDefault: 'Reset to default',
    accountId: 'Account ID', fillNewTokenPh: 'Enter new token to overwrite',
    retentionTitle: 'Data retention',
    retentionDesc: 'Retention days for each type of historical data; auto-cleaned when expired (daily 4:33). Enter 0 = keep forever. Accounts / landing pages / config are never cleaned.',
    retDataCol: 'Data', retDaysCol: 'Retention days', retDescCol: 'Description',
    foreverKeep: 'Keep forever', delBefore: 'Delete older than {n} days', lastClean: 'Last cleanup: {ts}',
    savePolicy: 'Save policy', cleaning: 'Cleaning…', cleanNow: 'Clean now',
    fxTitle: 'Exchange rates (stop-loss conversion)',
    fxDesc: 'FX rates for non-USD stop-loss conversion, auto-updated daily.',
    lastSync: 'Last sync: {ts} UTC', fetching: 'Fetching…', syncFxNow: 'Sync rates now',
    tgTitle: 'Telegram notifications',
    tgDesc: 'Bind your Telegram to receive real-time alerts (stop-loss / bans / anomalies). Click the button to open the Telegram bot and auto-bind.',
    tgAddAnother: '+ Add another Telegram',
    tgBoundBadge: '✅ Bound {id}', sending: 'Sending…', sendTestMsg: 'Send test message', unbind: 'Unbind',
    bindTelegram: 'Bind Telegram', bindLinkCopied: 'Bind link copied', cannotOpenCopy: 'Can\'t open? Copy link',
    tgBotNotConfigured: 'Admin has not configured a TG bot', verifyBotConfig: 'Verify bot config',
    tgManualHint: 'Button won\'t open? Send /start to the bot first, then paste the numeric ID from its reply to bind manually',
    tgManualPh: 'Telegram numeric ID (e.g. 123456789)', tgManualBind: 'Bind manually',
    tgManageBtn: 'Manage Telegram bindings (bind/unbind/list)',
    tgStartHint: 'The button will not re-send /start if the bot chat already exists — copy the command below and send it in the bot chat to bind (valid 30 min; "Copy command" gives a fresh one):',
    tgBoundToast: '✅ Telegram bound! Alerts will be sent to your Telegram',
    copyCmd: 'Copy command', cmdCopied: 'Command copied',
    verifyBotHint: 'Send a test message to the admin-configured bot to verify the bot works.',
    kaLockBusy: 'Keepalive scan is already running in the background. Try again shortly.', kaRunError: 'Keepalive failed: {msg}', keepaliveTitle: 'Keepalive protection (anti-sleep)',
    keepaliveDesc: 'Automatically create Page-like ads for accounts with no spend for N consecutive days to prevent FB bans. Keepalive ads are never stopped by stop-loss / sentinel.',
    kaOnLabel: 'Enabled (all accounts in this team are auto-included)', kaOffLabel: 'Disabled (only accounts with per-account keepalive enabled take effect)',
    kaMasterOn: 'Keepalive master switch: ON (keepalive runs normally)', kaMasterOff: 'Keepalive master switch: OFF (keepalive fully stopped, incl. per-account-enabled accounts)',
    kaBudget: 'Per-ad budget', kaTriggerDays: 'Trigger days', days: 'days', kaAssetPrefix: 'Asset prefix', saving: 'Saving…',
    // Sentinel countdown (dead-man switch)
    scdTitle: 'Sentinel Countdown', scdDesc: 'Automatically arm the sentinel when YOU have not logged in for a long time (campaigns on your managed accounts will be paused), preventing runaway spend while nobody is watching. Opening any page resets your countdown.',
    scdOnLabel: 'Enabled (auto-arm on timeout)', scdOffLabel: 'Disabled (never auto-arms)',
    scdHours: 'Inactivity threshold', hours: 'hours', scdOn: 'Sentinel countdown enabled',
    scdNote: 'A warning is sent at 75% of the countdown; auto-arm never auto-disarms — disarm manually in Rule Engine to resume delivery.',
  },
  teams: {
    title: 'Team Management',
    desc: 'All teams on the platform. Creating a team automatically generates 3 system roles and lets you designate the first owner. Archived teams are hidden but their data is retained.',
    summary: 'Teams {n} · Active {m} · Domains {d}',
    createTeam: 'Create Team', noTeams: 'No teams yet — click "Create Team" to add one',
    teamName: 'Team Name', members: 'Members', adAccounts: 'Ad Accounts', createdAt: 'Created At',
    manage: 'Manage', manageTitle: 'Team Management · {name}', rename: 'Rename', suspend: 'Suspend', activate: 'Activate', archive: 'Archive', restore: 'Restore',
    domains: 'Domains', domainTitle: 'Domains · {name}', domainAssigned: 'Assigned domains', domainNone: 'No domains (assign from platform pool below)',
    domainPool: 'Platform domain pool (all domains)', domainPoolEmpty: 'No domains in the platform pool', domainAssignedTo: 'Assigned to', domainFree: 'Free',
    domainSearch: 'Search domains', zoneActive: 'DNS active', zonePending: 'DNS pending', domainOccupied: 'Assigned to another team',
    domainRevoke: 'Revoke',
    hardDeleteTitle: 'Permanently Delete Team', hardDeleteBtn: 'Delete Permanently', hardDeleteConfirm: 'Permanently delete team "{name}" and ALL its data (accounts/templates/landing pages/alerts/logs, unrecoverable). Continue?', hardDeleted: 'Team permanently deleted',
    createDesc: 'Creating a team also generates 3 system roles (owner/operator/finance). You may designate the first owner (a user is auto-created and added).',
    teamNamePlaceholder: 'e.g. Client A Ads Team',
    ownerEmail: 'Owner Email', ownerEmailPlaceholder: 'Optional, leave blank to create an empty team first',
    ownerPassword: 'Owner Password', ownerPasswordPlaceholder: 'Optional, leave blank to auto-generate',
    creating: 'Creating…',
    memberManageTitle: 'Members · {name}', currentMembers: 'Current Members ({n})',
    you: 'You', noMembers: 'No members', addNewMember: 'Add New Member',
    email: 'Email', memberEmailPlaceholder: 'New member\'s email (joins directly if already exists)',
    role: 'Role', password: 'Password', memberPasswordPlaceholder: 'Leave blank to auto-generate',
    adding: 'Adding…', addMember: 'Add Member',
    loadFail: 'Failed to load', nameRequired: 'Team name is required', ownerEmailInvalid: 'Invalid owner email format',
    createdTeam: 'Team "{name}" created',
    ownerExisting: ', existing user {email} designated as owner',
    ownerNew: ', owner {email} initial password: {password} (please notify them to change it after first login)',
    emptyTeam: ' (empty team, members can be added later)', createdTitle: 'Team Created', createFail: 'Failed to create',
    newName: 'New team name', renameTitle: 'Rename · {name}', cannotEmpty: 'Cannot be empty', renamed: 'Renamed',
    confirmStatus: 'Set "{name}" to {status}?', statusUpdated: 'Updated',
    loadMembersFail: 'Failed to load members', roleChanged: '{email}\'s role changed to {role}', changeRoleFail: 'Failed to change role',
    removeMemberConfirm: 'Remove member "{email}"? (The user account is kept; only removed from this team)', memberRemoved: 'Removed {email}',
    emailRequired: 'Email is required', emailInvalid: 'Invalid email format',
    addedExisting: 'Existing user {email} added',
    addedNew: 'Created {email}, initial password: {password} (please notify them to change it after first login)',
    addSuccess: 'Added successfully', addFail: 'Failed to add', noRolesYet: 'No roles in this team (unexpected — system roles are created with the team; contact the platform)',
  },
  adm: {
    ...admanager.en,
    pageTitle: 'Ad Manager',
    loadAccountsFail: 'Failed to load accounts',
    budgetDaily: '{v}/day', budgetLifetime: '{v} total',
    budgetAdsetLevel: 'Ad set budget', budgetCampaignLevel: 'Campaign budget',
    drillCampaign: 'Campaign: {name}', drillAdset: 'Ad set: {name}',
    activated: 'Activated', paused: 'Paused', active: 'Active',
    budgetGtZero: 'Budget must be greater than 0', budgetUpdated: 'Budget updated',
    delConfirm: 'Delete "{name}"? This cannot be undone.', delCascadeCampaign: '⚠ Will also delete ALL ad sets and ads under it (irreversible on FB)', delCascadeAdset: '⚠ Will also delete all ads under it (irreversible on FB)', filterIdleTip: 'On but no ads delivering under it', deleted: 'Deleted',
    filterAbnormalTip: 'Disapproved / in review / with issues / banned and other abnormal states', accBannedTip: 'Account is disabled by Facebook or has a disable reason — status from cached snapshot', accUnmanagedTip: 'Token lost or unmanaged — data is the last snapshot; actions may not take effect', clearDrill: 'Exit drill-down',
    selectRowsFirst: 'Select ad rows first',
    batchPauseConfirm: 'Pause {n} ads?', batchPauseTitle: 'Confirm batch pause',
    batchResult: '{ok}/{n} succeeded', batchOpFail: 'Batch operation failed',
    diagFail: 'Diagnosis failed: {msg}',
    redirectSet: 'Redirect link set', redirectRestored: 'Restored default redirect',
    resetRedirectsMsg: 'Clear all ad redirect overrides? All ads will revert to the landing-page default redirect.', redirectsCleared: 'Cleared {n}',
    customRange: 'Custom', allAccounts: 'All accounts', searchNameId: 'Search ad name / ID',
    redirectLink: 'Redirect link', selectedCount: '{n} selected', selectAll: 'Select all / clear',
    batchBudget: 'Batch Budget', batchBudgetTitle: 'Batch Update Budget', batchBudgetType: 'Budget type', batchBudgetDaily: 'Daily budget', batchBudgetLifetime: 'Lifetime budget', batchBudgetAmount: 'Amount', batchBudgetPh: 'Enter new budget amount', batchBudgetNote: 'Amount is in each account local currency; applies to all selected campaigns/ad sets.', batchBudgetMixedCur: 'Selection spans multiple currencies: the same number is set per local currency — double-check the intent.', batchBudgetConfirm: 'Set {type} of {n} items to {v}. Proceed?',batchActivate: 'Batch Activate', batchPause: 'Batch Pause', clearSelection: 'Clear selection',
    tabCampaign: 'Campaigns', tabAdset: 'Ad Sets', tabAd: 'Ads',
    colSeries: 'Campaign', colAdset: 'Ad Set', colObjective: 'Objective', colOptGoal: 'Optimization Goal', colPixel: 'Pixel',
    colBudget: 'Budget', colSpend: 'Spend', colConversion: 'Conv.', colReach: 'Reach', colFrequency: 'Frequency',
    colSubcode: 'Subcode', colVisits: 'Visits', colPass: 'Pass', colPassRate: 'Pass Rate',
    lpVisit: 'Landing visits', lpPass: 'LP clicks', lpTip: 'Visits = real people reaching the LP; LP clicks = button clicks or redirects (dedup) — FB clicks include likes/comments, different calibers',
    activate: 'Activate', editBudget: 'Edit Budget', redirectShort: 'Redirect',
    tabLead: 'Leads',
    leadsCount: '{n} leads', leadsSync: 'Sync from FB', leadsSubscribe: 'Subscribe Page Webhook',
    leadsHint: 'Pages push leads in real time; manual sync fills in answers',
    leadsSynced: '{n} synced', leadsSubscribed: 'Subscribed {ok}/{n} pages', leadsErr: '{msg}',
    leadsUnsubscribe: 'Unsubscribe Webhook', leadsUnsubConfirm: 'This stops live lead push for ALL pages (full lead details). You will need to re-subscribe to receive leads again. Continue?',
    leadsUnsubscribed: 'Unsubscribed {ok}/{n} pages', bgRefreshing: 'Refreshing in background… will update automatically',
    refetchDone: 'Ad list updated; clicks & spend sync every 5 minutes',
    pagesPanelBtn: 'Pages & Subscription', pagesPanelTitle: 'Page Control Status', pagesPanelHint: 'Permissions are set on the Facebook side (the platform cannot raise them): "Full" = advertise + lead push; "Ads only" = advertise only; "View" = neither. Subscribed = live lead push active',
    ppColPage: 'Page', ppColPerm: 'Permission', ppColSub: 'Subscribed', ppManage: 'Full', ppAdvertise: 'Ads only', ppAdvertiseTip: 'Can run ads, but webhook subscription requires the "Manage Page" task (assign in BM/page settings)',
    ppView: 'View', ppViewTip: 'This token has view-only access on the page — neither advertising nor subscription works', ppNoManage: 'No "Manage Page" task — cannot subscribe',
    ppSubscribed: 'Yes', ppEmpty: 'No pages yet (authorize an account with pages on the Tokens page first)', ppSubscribeSelected: 'Subscribe selected ({n})',
    purgeStaleBtn: 'Clean up stale pages', purgeStaleConfirm: 'Deletes leads from pages no longer covered by any active token and archives their form templates (future events from those pages are also dropped). This cannot be undone. Continue?',
    purgeStaleDone: 'Cleaned: {leads} leads, {tpls} form templates',
    leadsEmpty: 'No leads yet (sync after deploying an Instant Form, or pages push via webhook)',
    lcolTime: 'Submitted', lcolName: 'Name', lcolEmail: 'Email', lcolPhone: 'Phone', lcolSource: 'Source', lcolDetail: 'Details',
    lfCity: 'City', lfState: 'State', lfZip: 'Zip', lfCountry: 'Country', lfGender: 'Gender', lfDob: 'DOB',
    lfMarital: 'Marital', lfCompany: 'Company', lfJob: 'Job Title', lfAddress: 'Address', lfEmps: 'Employees',
    leadStatus: { new: 'New', contacted: 'Contacted', won: 'Won', lost: 'Lost' },
    lcolStatus: 'Status', lcolNote: 'Note',
    leadStatusUpdated: 'Status updated', leadNoteUpdated: 'Note saved',
    leadNoteTitle: 'Follow-up Note · {name}', leadNotePrompt: 'Log your follow-up (save blank = clear note)',
    leadNoteTooLong: 'Note too long (max 2000 chars)',
    redirectMarkTitle: 'Redirect set: {url} (click to edit)',
    slugTitle: '/a/{slug} · {pass} passed (click for landing page logs)',
    slugEmpty: 'Not laid', slugEmptyTitle: 'No landing traffic yet (the subcode binds automatically once there are visitors)',
    lvTitle: 'Landing visits', lpTitle: 'Pass count = button clicks + redirects (IP-deduped)',
    lprTitle: '{pass} passed / {visits} visits', noVisits: 'No visits', viewLandingLogs: 'View landing page logs',
    adDiagnose: 'Ad Diagnosis', reuseThisPost: 'Reuse This Post', editBudgetTitle: 'Edit Budget · {name}',
    lifetimeBudgetLabel: 'Lifetime budget (local currency)', dailyBudgetLabel: 'Daily budget (local currency)',
    redirectDialogTitle: 'Redirect Link · {name}', redirectFormLabel: 'Dedicated redirect link for this ad',
    redirectInputPh: 'https://... (blank = use landing default)',
    redirectHint: 'Once set, all visitors of this ad redirect to this link; other ads are unaffected. Save blank = restore landing default.',
    restoreDefault: 'Restore default', redirectMgmtTitle: 'Ad Redirect Link Management',
    redirectMgmtCount: '{n} ads with custom redirect', restoreAllDefault: 'Restore all to default',
    redirectMgmtEmpty: 'No ads have a custom redirect (all use landing default)',
    diagBasicInfo: 'Basic Info', diagAccount: 'Account', diagAdId: 'Ad ID', unbound: 'Unbound',
    diagFbStatus: 'FB Status', diagTodayData: 'Today\'s data ({tz})',
    diagImpressions: 'Impressions', diagClicks: 'Clicks', diagFbConv: 'FB Conversions',
    diagLandingClicks: 'Landing Clicks', diagLandingVisits: 'Landing Visits', diagEffectiveConv: 'Effective Conversions',
    dedupIp: 'Deduped IP', diagRuleEval: 'Rule Evaluation', colLandingShort: 'Landing', effectiveShort: 'Eff.',
    diagNoRules: 'No active rules', diagCooldown: 'Cooldown',
    diagCooldownMsg: '🔒 Rule "{rule}" paused this ad {ago} min ago; rule cooling down (no repeat action for the next {left} min)',
    diagWhitelisted: 'Whitelisted today (inspection skips this ad)', diagRecentActions: 'Recent Actions',
    objSales: 'Sales', objTraffic: 'Traffic', objEngagement: 'Engagement', objAwareness: 'Brand Awareness',
    objLead: 'Leads', objMessages: 'Messages', objPageLikes: 'Page Likes', objVideoViews: 'Video Views', objReach: 'Reach',
    optConversion: 'Conversions', optLinkClicks: 'Link Clicks', optLandingViews: 'Landing Page Views',
    optImpressions: 'Impressions', optAppInstalls: 'App Installs', optLeadGen: 'Lead Gen',
    optMsgConv: 'Messaging Conversations', optValue: 'Value',
    ruleBleedAbs: 'Empty Spend Stop', ruleCpaExceed: 'CPA Exceeded', ruleConsecutiveBad: 'Consecutive Decline', ruleCpmHigh: 'High CPM', ruleCpcHigh: 'High CPC', ruleClickFraud: 'Click Fraud', ruleFastScale: 'Fast Scale',
    ruleClickNoConv: 'Clicks No Conversion', ruleReachNoConv: 'Reach No Conversion', ruleLowCtrNoConv: 'Low CTR No Conversion',
    ruleBudgetBurnFast: 'Fast Burn Stop', csFb: 'Facebook only', csLanding: 'Landing only', csEither: 'Combined (max)',
    mixedCurrencyTip: 'Selected accounts use multiple currencies — spend/CPA converted to USD',
    dataAsOf: 'Data as of {t}', dataAsOfAgo: ' ({v})', dataAsOfTip: 'Clicks and spend are updated automatically every 5 minutes by the inspection loop', cacheStaleTip: 'Data is over 1 hour old — refresh recommended',
    cacheAge: 'Data {n} min ago', cacheAgeLt1: 'Data <1 min', cacheAgeNone: 'Data —',
    cacheAgeSingle: 'Data {v}', cacheAdsStaleTip: 'Ad layer is over 1 hour old — refresh recommended',
    cacheAgeShort: '{n} min ago', cacheAgeLt1Short: '<1 min',
    cacheAgeTip: 'Ad status updates about every 5 min; structure every ~15 min. "Live Verify" fetches the latest platform statuses instantly',
    emptyAdsHint: 'No data — try widening the date range or switching the account filter; deploy new ads from "Launch Templates"',
    tokenDeadBar: '{n} accounts have no usable token — their statuses are last-known snapshots. Re-authorize on the Tokens page',
    tokenDeadTip: 'Data connection lost — updates stopped; the list shows the last known status. Re-authorizing restores live data',
    snapTag: 'snap', snapTagTip: 'Data connection lost for this account — showing the last known status (not live). Re-authorize to restore', accUnmanaged: 'Removed', accBanned: 'Banned', accUnmanagedTip: 'No usable token (unmanaged or expired) — cannot pause/monitor; showing last snapshot. Rebind a token', accBannedTip: 'Account disabled by Facebook; all ads stopped', accUnmanagedBanner: 'No usable token (unmanaged or expired) — cannot pause/monitor; showing last snapshot. Rebind a token', accBannedBanner: 'This account is disabled by Facebook — all ads have stopped', convDual: 'FB Results {fb} / Total Conv {total}',
    belongsToCampaign: 'Campaign: {name} (click the name to view ad groups under this campaign)',
    refreshTip: 'Refetch all data (1-2 min in background). Use "⚡ Live Verify" for an instant status check', refreshCacheTip: 'Reload current data', refetch: 'Refetch',
    refreshCacheShort: 'Refresh from cache', srBtn: 'Copy spend accounts', srBtnTip: 'Row-level spend for the current filters (includes history of removed accounts)', srLoading: 'Fetching…',
    srTitle: 'Spend report ({range})', srMeta: '{live} live · {db} DB',
    srBasis: 'Per account local day (same as dashboard)', srBasisTip: 'Counted in each account\'s own timezone (same as the dashboard)',
    srOnlySpend: 'Only accounts with spend in window',
    srDate: 'Date', srOwner: 'Owner', srAccName: 'Account', srAccId: 'Account ID', srSpend: 'Spend (USD)', srSource: 'Source', srStatus: 'Status',
    srLive: 'Live', srDb: 'DB', srManaged: 'Managed', srRemoved: 'Removed',
    srLastRec: 'Last record', srLastRecTip: 'Removed account\'s last DB day with spend before removal (reference only, not counted in the window)',
    srCopy: 'Copy', srCopied: 'Copied {n} rows (paste directly into spreadsheets)', srEmpty: 'No accounts with spend in the selected window',
    liveVerify: 'Live Verify', liveVerifying: 'Verifying…', liveVerifyTip: 'Checks on/off status only (instant), not names/creatives/spend; use "Refetch" in the header for a full update',
    liveVerifiedAt: 'Live verified {time}', liveVerifyOk: 'Live-verified {n} ad statuses', liveVerifyFail: 'Live verification failed',
    liveVerifyPickAccount: 'Select account(s) in the account filter above first', liveVerifyTooOften: 'Already verified within the last 10s; please wait',
    fakePauseWarn: 'Submitted, but read-back verification shows the status did not take effect (possible fake pause) — run "Live Verify" to re-check',
    batchActivateConfirm: 'About to resume delivery of {n} ads', batchActivateTitle: 'Confirm Batch Activate',
    budgetBigJumpTitle: 'Confirm Large Budget Increase', budgetBigJumpConfirm: 'Large budget change: {change}. Apply?',
    reviewFlagTitle: 'Rejection Reason', reviewFlagHint: 'Click to view rejection reason', thumbTitle: 'Creative Thumbnail',
    redirectRemoveConfirm: 'Remove the custom redirect for this ad? It will fall back to the default target.',
    loadFailed: 'Failed to load data',
    thumbNoneShort: 'No preview', thumbArchivedShort: 'Archived', thumbNone: 'The platform did not return a preview image for this ad', thumbArchived: 'Archived ad: creative expired, the platform no longer provides a preview',
    rename: 'Rename', renameTitle: 'Rename · {name}', renamePrompt: 'New name',
    renameEmpty: 'Name cannot be empty', renameTooLong: 'Name must be 200 characters or fewer', renamed: 'Renamed',
    filterAbnormal: 'Issues', scopeAccounts: '{n} accounts', totalRow: 'Total ({n})',
    shownOf: 'Showing {s} of {n} — scroll to load more',
  },
  kpi: {
    loadFail: 'Failed to load',
    resetConfirm: 'Reset all mappings to system defaults? Your custom config will be overwritten.',
    resetDone: 'Reset to defaults', resetDefault: 'Reset to Defaults',
    tabMatrix: 'Mapping Matrix', tabObjective: 'Unknown-objective Fallback', tabFallback: 'Fallback Priority',
    ttObjectiveHint: 'TikTok values are resolved by campaign objective; conversions follow the platform report.',
    ttNoMatrix: 'TikTok objectives are single-level; no matrix needed (see the Unknown-objective Fallback TikTok group).',
    ttNoFallback: 'TikTok conversions come directly from the report; no fallback needed.',
    ttNoPoor: 'TikTok report conversions are already aggregated by objective; no metrics to exclude.',
    tabPoor: 'Excluded Metrics', tabLabels: 'Metric Names',
    fallbackHint: 'Auto-detection picks the first non-zero conversion by this priority',
    poorHint: 'These metrics are not counted as conversions (view/click/engagement types); skipped by auto-detection',
    labelsHint: 'Conversion metric → display name',
    fieldPurchase: 'Purchase', fieldLead: 'Lead', fieldMessaging: 'Messaging',
    fieldAppInstall: 'App Install', fieldRegistration: 'Registration', fieldPageLike: 'Page Like',
    fieldPostEngagement: 'Post Engagement', fieldLinkClick: 'Link Click', fieldLandingView: 'Landing View',
    fieldVideoView: 'Video View', fieldThruplay: 'ThruPlay', fieldAddToCart: 'Add to Cart',
    fieldInitiateCheckout: 'Initiate Checkout', fieldTtConversion: 'Conversion (TT)',
    matrixEmpty: 'Mapping matrix is empty — conversion detection uses system defaults (auto-filled once new objectives appear).',
  },
  dashboard: dashboard.en,
  launch: launch.en,
  formtpl: formtpl.en,
  assets: assets.en,
  lm: {
    batchImport: 'Batch Import', addOne: 'Add One', count: '{n} items',
    itemUrl: 'URL', itemDomain: 'Domain',
    edit: 'Edit',
    tipUrl: 'Paste one URL per line (lines starting with # are ignored). https:// is auto-prefixed when missing; duplicates skipped.',
    tipDomain: 'Paste one domain per line (e.g. lp.example.com). Scheme/path stripped, lowercased; duplicates skipped.',
    taPh: 'https://example.com/offer1 (one per line, paste many)',
    recognize: 'Recognize', found: '{n} items recognized', dupSkipped: '{n} duplicates skipped',
    invalidN: '{n} unrecognized:', badUrl: 'not a valid URL', badDomain: 'not a valid domain',
    importBtn: 'Import {n}', imported: 'Imported {n} items',
  },
  bm: {
    total: '{n} Business Managers', colBm: 'Business Manager', colVia: 'Owning token', colRole: 'Role',
    tabMembers: 'Members', tabAssets: 'Assets', colPage: 'Owned Pages',
    accCount: 'Ad accounts {n}', pgCount: 'Pages {n}', noMembers: 'No member data (or token lacks permission)',
    needEmail: 'Enter an email', invite: 'Invite', emailPh: 'Member email (Facebook account)', adminConfirm: 'ADMIN can manage all members and assets of this BM (including adding/removing other admins). Grant this?', removeConfirm: 'Remove member "{n}"? Their BM access ends immediately.', writeBlocked: 'BM management is unavailable: the Facebook App needs business_management approved (App Review) and must be in Live Mode; it auto-enables once approved.', invited: 'Invitation sent', noAssets: 'No asset data (or token lacks permission)', none: 'No Business Managers yet', roleFull: 'Full control', roleEmployee: 'Employee',
  },
  pg: {
    unpublished: 'Unpublished',
    searchPh: 'Search page / ID / token', total: '{n} pages',
    colPage: 'Page', colVia: 'Owning token', colCat: 'Category', colFans: 'Fans', colAds: 'Live ads', colTpl: 'Template refs',
    tplN: '{n}', copyId: 'Click to copy ID', noMatch: 'No matching pages', none: 'No pages yet (no token or no managed pages)', renameBtn: 'Rename', categoryBtn: 'Change Category', categoryPh: 'Search or type a category', pageRenamePrompt: 'New page name (renames the real Facebook page)', pageRenameLimit: 'Name must be 1-100 characters', pageRenamed: 'Page renamed', pageCategoryPrompt: 'New page category (e.g. "Internet Marketing Service"). Requires page manage permission.', pageCategoryLimit: '1-120 chars', pageCategorySaved: 'Page category updated',
  },
  domains: {
    tabBuy: 'Buy Domains', tabMine: 'My Domains', tabOrders: 'Orders',
    srcPurchased: 'Purchased', srcOwn: 'Own', zoneActive: 'DNS active', zonePending: 'DNS pending',
    usedBy: 'used by {n} pages', noUse: 'No landing pages using this domain', noMine: 'No team domains yet — buy one or bind your own', goBuy: 'Buy a domain',
    approve: 'Confirm payment', approveOk: '{d} payment confirmed — registering & connecting (will appear in My Domains)', approveParked: '{reg} credentials not configured — order marked as paid; configure the registrar then click "Confirm payment" to resume',
    takenNow: '{d} was just taken or unavailable — removed from the list, try another', payPoolN: 'Click "Pay" to see this order\'s receiving address',
    scanPay: 'Scan to pay (TokenPocket/TronLink)', netOnly: 'Supports USDT-TRC20 (TRON network) — the most common USDT rail', netWarn: 'Do NOT use ERC20/BEP20 or the wrong withdrawal network — assets sent on the wrong network cannot be recovered', payDomain: 'Domain', payAmtLabel: 'Amount due', amtCopied: 'Amount copied', waitingPay: 'Waiting for payment…', payAutoDetect: 'Auto-confirmed and delivered ~1-2 min after your transfer — no manual step.', payBtn: 'Pay', payTo: 'Send USDT to:', payCopied: 'Payment address copied', stDetected: 'Paid · registering', payAmt: 'Pay ${v}', payAmtTip: 'Transfer exactly this amount; confirmation is automatic on arrival', orderedPay: 'Ordered — pay ${v} (USDT; address on the Orders tab)', listNote: 'All-inclusive prices (cheapest first) · availability & live price verified at checkout', costBrkTip: 'Cost breakdown: domain cost + platform fee (superadmin only)',
  },
  wallet: {
    tab: 'Wallet', balanceLabel: 'Team balance', balanceTip: 'Team balance = platform wallet (purchases/renewals deduct here); ad-account credit is in the Ads list', teamNote: 'shared by the team (purchases/renewals deduct here)',
    topupBtn: 'Top up', topupTitle: 'Wallet top-up', amtLabel: 'Amount', amtPh: 'e.g. 100', amtMin: 'Top-up must be at least 1 USD',
    topupHint: 'USDT transfer arrives automatically in ~1-2 min, no manual step.',
    topupGo: 'Get payment info', topupCancelled: 'Top-up cancelled',
    allTeams: 'All team balances', total: 'Total', noAccounts: 'No team wallets yet (created on first top-up or purchase)',
    adjustBtn: 'Adjust', adjustTitle: 'Manual wallet adjustment', adjAmtLabel: 'Amount (±)', adjAmtPh: 'e.g. 50 or -20',
    adjNoteLabel: 'Reason (required)', adjNotePh: 'e.g. refund for order #12 / correction / grant',
    adjHint: 'Positive adds, negative deducts; every entry is recorded in the ledger and the audit log.',
    adjAmtRequired: 'Enter an amount (±)', adjNoteRequired: 'Enter a reason', adjDone: 'Adjusted, balance ${v}',
    txnsTitle: 'Transactions (last 50)', noTxns: 'No transactions yet',
    txDeposit: 'Deposit', txCharge: 'Purchase', txRefund: 'Refund', txAdjust: 'Adjust',
    balAfter: 'Bal.', refTopup: 'Top-up #{id}', refOrder: 'Order #{id}', refOrderRefund: 'Order #{id} refund',
  },
  dom: {
    expTitle: 'Expires {d}', expDays: '{n} days left', expToday: 'expires today', expExpired: 'expired',
    autoRenew: 'Auto-renew', autoTip: 'When on: renews automatically (1 yr) before expiry if the wallet is funded; low balance triggers an early reminder',
    autoOn: 'Auto-renew on', autoOff: 'Auto-renew off',
    renewBtn: 'Renew', renewTitle: 'Renew · {d}', curExpires: 'Current expiry', renewYears: 'Years',
    yearsN: '{n} yr', renewPrice: 'Price', perYear: '${v}/yr',
    payWallet: 'Balance sufficient — confirming charges and renews instantly.', payUsdt: 'Insufficient balance — a USDT direct-pay order will be created and auto-renews on arrival (or top up first).',
    renewGo: 'Confirm renew', renewDone: 'Renewed, new expiry {d}', renewOrderCreated: 'Renewal order created — pay ${v} (Orders tab)',
    regExternal: 'Own domain', regNone: 'Own domain', regPlatform: 'Purchased via platform', lastRenewed: 'Last renewed {d}',
  },
  landing: landing.en,
  guard: guard.en,
  lplogs: lplogs.en,
}
